import { Select_Option_default } from "./chunk-EIUFV4NU.js";
import { Select_default } from "./chunk-X553MXXL.js";

// src/elements/Select/index.ts
var SelectComponent = Select_default;
SelectComponent.Option = Select_Option_default;
SelectComponent.Option.displayName = "Select.Option";
export { SelectComponent };